class StickyAtcPanel extends HTMLElement {
  constructor() {
    super();
  
    this.threshold = 200;
    this.lastScrollY = 0;
    this.ticking = false;
    
    this.priceElement = this.querySelector('.price');
    this.imageElement = this.querySelector('.card__media img');
    this.addButton = this.querySelector('.btn');
    this.variantInput = this.querySelector('input[name="id"]');
    this.quantityInput = this.querySelector('#sticky-quantity-input');

    this.mainForm = document.querySelector('.js-product-form');
    
    this.init();
  }

  init() {
    if (!this.descriptionAnchorExists()) {
      console.log("Âncora de descrição não encontrada, desativando sticky panel");
      return;
    }
    
    window.addEventListener('scroll', this.handleScroll.bind(this));
    document.addEventListener('variant:changed', this.updateVariantInfo.bind(this));

    if (this.quantityInput) {
      this.quantityInput.addEventListener('change', this.syncQuantity.bind(this));
    }
    
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
    
    this.update();
  }

  syncQuantity() {
    const mainQuantityInput = document.querySelector('.js-product-form input[name="quantity"]');
    if (mainQuantityInput && this.quantityInput) {
      mainQuantityInput.value = this.quantityInput.value;
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    
    this.addButton.disabled = true;
    const originalText = this.addButton.textContent;
    this.addButton.textContent = '';

    try {
      const formData = new FormData();
      formData.append('id', this.variantInput.value);
      formData.append('quantity', this.quantityInput ? this.quantityInput.value : 1);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      const item = await response.json();
      
      await this.updateCartCount();
      
      await this.refreshCartDrawer();
      
      this.openCartDrawer();
      
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      this.addButton.disabled = false;
      this.addButton.textContent = originalText;
    }
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const cartCountBubble = document.querySelector('#cart-icon-bubble .header__cart-count');
      if (cartCountBubble) {
        const countNumber = cartCountBubble.querySelector('.header__cart-count-number');
        if (countNumber) {
          countNumber.textContent = cart.item_count;
        }
        if (cart.item_count > 0) {
          cartCountBubble.style.display = 'flex';
        } else {
          cartCountBubble.style.display = 'none';
        }
      }

      const cartCounts = document.querySelectorAll('[data-cart-count]');
      cartCounts.forEach(element => {
        element.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  async refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    
    return new Promise((resolve) => {
      setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.refresh === 'function') {
          cartDrawer.refresh();
        }
        resolve();
      }, 100);
    });
  }

  openCartDrawer() {
    console.log('Attempting to open cart drawer...');
    
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
      detail: { 
        opener: this.addButton,
        source: 'sticky-atc-panel'
      }
    }));

    setTimeout(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      console.log('Cart drawer state:', {
        element: cartDrawer,
        ariaHidden: cartDrawer ? cartDrawer.getAttribute('aria-hidden') : 'not found',
        hasOpenMethod: cartDrawer && typeof cartDrawer.open === 'function'
      });
      
      if (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'true') {
        if (typeof cartDrawer.open === 'function') {
          console.log('Calling open() method directly...');
          cartDrawer.open(this.addButton);
        } else {
          console.log('Redirecting to cart page...');
          window.location.href = '/cart';
        }
      }
    }, 300);
  }

  descriptionAnchorExists() {
    return !!document.getElementById('description-anchor');
  }

  handleScroll() {
    this.lastScrollY = window.scrollY;
    
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  update() {
    const anchor = document.getElementById('description-anchor');
    if (!anchor) return;
    
    const anchorRect = anchor.getBoundingClientRect();
    const isPastAnchor = anchorRect.bottom < 0;
    const isNearTop = window.scrollY < this.threshold;
    const isNearBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100;
    
    if (isPastAnchor && !isNearTop && !isNearBottom) {
      this.classList.add('active');
    } else {
      this.classList.remove('active');
    }
  }

  updateVariantInfo(event) {
    const variant = event.detail.variant;
    
    if (this.priceElement) {
      this.priceElement.innerHTML = `
        <span class="price__current">
          ${Shopify.formatMoney(variant.price)}
        </span>
      `;
    }
    
    if (this.imageElement && variant.featured_media) {
      this.imageElement.src = variant.featured_media.preview_image.src;
      this.imageElement.srcset = variant.featured_media.preview_image.srcset;
      this.imageElement.alt = variant.featured_media.preview_image.alt || '';
    }
    
    if (this.addButton) {
      if (variant.available) {
        this.addButton.removeAttribute('disabled');
        this.addButton.textContent = this.addButton.dataset.addToCartText || 'Add to cart';
      } else {
        this.addButton.setAttribute('disabled', 'disabled');
        this.addButton.textContent = 'Sold out';
      }
    }

    if (this.variantInput) {
      this.variantInput.value = variant.id;
    }
  }
}

if (!customElements.get('sticky-atc-panel')) {
  customElements.define('sticky-atc-panel', StickyAtcPanel);
  
  document.addEventListener('DOMContentLoaded', () => {
    const panel = document.querySelector('sticky-atc-panel');
    if (panel) {
      new StickyAtcPanel();
    }
  });
}